import React from "react";
import s from "./UnauthorizedPage.module.css";
import msLogo from "../../../assets/images/common/MotorsportLogo.png";

export const UnauthorizedPage = () => {
  return (
    <div className={s.wrapper}>
      <div className={s.mainContainer}>
        <h2 className={s.title}>Want to see racing visualization?</h2>
        <p className={s.message}>
          Visit us{" "}
          <a href="https://motorsportstats.com/" target="_blank">
            www.motorsportstats.com
          </a>
        </p>
        <p className={`${s.message} ${s.secondMessage}`}>
          Want to be a partner?
          <br /> Ask us: <a href="mailto:sales@motorsportstats.com">sales@motorsportstats.com</a>
        </p>
      </div>
      <div className={s.footer}>
        <span className={s.powered}>Powered by</span>
        <a href="https://motorsportstats.com/" target="_blank">
          <img src={msLogo} alt={"MOTORSPORT STATS"} width="91px" />
        </a>
      </div>
    </div>
  );
};
